"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClasses = addClasses;
exports.resetClassList = resetClassList;
exports.canAnimate = canAnimate;

var toList = function toList(classes) {
  return (classes || "").split(/\s+/g);
};

function addClasses(node, classString) {
  if (!node) return;
  toList(classString).forEach(function (className) {
    return node.classList.add(className);
  });
}

function resetClassList(node, classNames) {
  if (!node) return;
  Object.values(classNames || {}).forEach(function (value) {
    toList(value).forEach(function (className) {
      return node.classList.remove(className);
    });
  });
}

function canAnimate() {
  var raf = !!(window && window.requestAnimationFrame);
  var classList = !!(document && document.body && document.body.classList);
  return raf && classList;
}